<script src="../crossed-tables/cost-registrations.component.ts"></script>
<div class="col-md-12 pt-4 px-3" style="display: flex;flex-wrap: wrap">
  <primary-text-button
    *ngFor="let service of services"
    [noLeftPadding]="true"
    (onClick)="serviceSelected(service.id)"
    style="padding-inline-end: 1rem;margin-bottom: 1rem;outline: none"
    >{{ service.text }}
  </primary-text-button>
</div>

<div *ngIf="serviceId" class="col-12">
  <div class="row mt-3">
    <div class="col-md-12" style="display: flex;align-items: center">
      <input
        placeholder="{{ 'Search' | translate }}"
        class="form-control form-control-sm"
        #searchInput
        (input)="searchTextChanged($event.currentTarget.value)"
        name="searchInput"
        type="text"
      />
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12">
      <primary-text-button
        [noLeftPadding]="true"
        [disabled]="isLoading"
        (onClick)="saveRegistrations()"
      >
        {{ 'Save' | translate }}
      </primary-text-button>
    </div>
  </div>
</div>

<div *ngIf="serviceId" class="col-12">
  <!--div class="row mb-2 mt-2">
        <div class="col-md-6">
            <input class="form-control form-control-sm"
                   type="text"
                   [(ngModel)]="value"
                   placeholder="Registration group name">
        </div>
        <div class="col-md-6">
            <primary-text-button (onClick)="addNewClassificationGroup()">{{'classification.add_group' | translate }}
            </primary-text-button>
        </div>
    </div-->
  <table class="table table-striped table-condensed">
    <thead class="thead-inverse">
      <tr>
        <th>&nbsp;</th>
        <th>{{ 'classification.other.key' | translate }}</th>
        <th style="text-align:left;">
          {{ 'classification.other.value' | translate }}
        </th>
        <th>&nbsp;</th>
        <th>&nbsp;</th>
        <!--th *ngFor="let group of groups; let i = index;" style="vertical-align:middle;">
                    <div style="display: flex;align-items: center">
                        {{ group.name | translate}}
                        <icon (click)="showWarningModal = true; selectedForDeleteItem = group"
                              className="fa-close"
                              class="list-option-control-icon remove-icon"></icon>
                    </div>
                </th-->
        <th>&nbsp;</th>
      </tr>
    </thead>
    <tbody
      cdkDropList
      [cdkDropListData]="registrations"
      (cdkDropListDropped)="dropped($event)">
      <tr
        *ngFor="let row of registrations | filterBy: userFilter; let i = index; trackBy: trackByFn"
        cdkDrag>
        <td>
          <i class="fas fa-arrow-up mx-1" style="font-size:0.8rem"></i>
          <i class="fas fa-arrows-alt handle mx-1" style="font-size:0.8rem"></i>
        </td>
        <td>
          <input
            (keyup.enter)="addNewRegistration()"
            name="key"
            class="form-control form-control-sm"
            type="text"
            [(ngModel)]="row.key"
            required
          />
        </td>
        <td style="width:20%">
          <input
            (keyup.enter)="addNewRegistration()"
            name="name"
            class="form-control form-control-sm"
            type="text"
            [(ngModel)]="row.name"
            required
          />
        </td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <!--td *ngFor="let group of groups; let i = index;">
                    <i id="inGroup"
                       class="fas {{getGroupValue(group.id, row.id) ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-off toggle-disabled'}}"
                       (click)="setSetGroupValue(group.id, row.id)"></i>
                </td-->
        <td>
          <confirmation
            [showTrashIcon]="true"
            [buttonName]="'general.delete'"
            [question]="'confirm.areyousure'"
            (isConfirmed)="removeRegistration($event, row.id)"
          >
          </confirmation>
        </td>
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td>
          <input
            class="form-control form-control-sm"
            type="text"
            [(ngModel)]="key"
            placeholder="{{ 'Registration field key' | translate }}"
          />
        </td>
        <td>
          <input
            class="form-control form-control-sm"
            type="text"
            [(ngModel)]="value"
            placeholder="{{ 'Registration field value' | translate }}"
          />
        </td>
        <td style="text-align:center;">
          <primary-text-button (onClick)="addNewRegistration()"
            >{{ 'general.add' | translate }}
          </primary-text-button>
        </td>
        <td>
          <!--a class="btn btn-default btn-sm"
                       href="assets/example_catalogue.xlsx">{{'classification.other.downloadTemplate' | translate}}</a-->
        </td>
        <td>&nbsp;</td>
        <!--td [attr.colspan]="languages.length"></td-->
      </tr>
      <tr>
        <td>&nbsp;</td>
        <td>
          <label class="">{{
            'classification.other.select_classification' | translate
          }}</label>
        </td>
        <td style="text-align:center;">
          <ng-select
            [(ngModel)]="selectedClassificationValue"
            bindLabel="text"
            bindValue="id"
            [items]="classifications"
            (add)="selected($event)"
            class="custom"
          ></ng-select>
        </td>
        <td style="text-align:center;">
          <primary-text-button
            (onClick)="generateRegistrationsAndDeterminants()"
            >Generate catalogue registrations
          </primary-text-button>
        </td>
        <td>
          <label
            class="upload-button file-input-wrapper btn btn-secondary btn-sm"
            style="    border-radius: 3.125rem;"
          >
            <input
              type="file"
              class="hidden"
              (change)="onFileChange($event)"
              multiple="false"
            />
            {{ 'classification.other.uploadCatalog' | translate }}
          </label>
        </td>
        <td>&nbsp;</td>
      </tr>
    </tbody>
  </table>

  <confirmation-modal
    *ngIf="showWarningModal"
    [show]="showWarningModal"
    question="{{ 'Do you want to delete' | translate }}?"
    (onNo)="showWarningModal = false"
    (onYes)="showWarningModal = true"
  > <!-- fix me onYes doesnt work properly-->
  </confirmation-modal>
</div>
